export function removeSpinner() {
  const spinner = document.getElementById('app-spinner')
  if (spinner)
    spinner.parentElement?.removeChild(spinner)
}
